import React from 'react';
import { Home, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PostInstallHelperCardProps {
  onDismiss: () => void;
  className?: string;
}

export const PostInstallHelperCard: React.FC<PostInstallHelperCardProps> = ({ onDismiss, className = '' }) => {
  return (
    <div className={`relative bg-primary/10 border border-primary/20 rounded-lg p-4 ${className}`}>
      <button
        onClick={onDismiss}
        className="absolute top-2 right-2 p-1 rounded-full hover:bg-muted/50 transition-colors"
        aria-label="Dismiss home screen tip"
      >
        <X className="h-4 w-4 text-muted-foreground" />
      </button>

      <div className="flex items-start gap-3 pr-6">
        <div className="shrink-0 p-2 bg-primary/10 rounded-full">
          <Home className="h-5 w-5 text-primary" />
        </div>

        <div className="flex-1 space-y-2">
          <h3 className="font-semibold text-sm text-foreground">
            Icon in your app drawer?
          </h3>
          <p className="text-xs text-muted-foreground">
            On many Android phones, LupusLogix installs to the app drawer first. Swipe up from your home screen to open the drawer, then long-press the icon and tap <span className="font-medium text-foreground">"Add to Home screen"</span>.
          </p>
          <Button
            onClick={onDismiss}
            size="sm"
            variant="outline"
            className="mt-2"
          >
            Got it
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PostInstallHelperCard;
